export default __webpack_public_path__ + "static/media/754.0b56d463.png";